import React from 'react'
import * as h from '../../helpers/helpers';
import * as c from '../../data/certifications';
import * as rf from '../../data/reportFunctions';
import { lu } from '../../data/reportData';
import { H1, H2, TAB, TX_B, TXC, TXC_B, TXR_B, TXR_I, TXR_II } from "../../styles/urar-styles";

export function END_NOTES() {

	return (
		<>
			<PARAGRAPH text={c.SOWIntro} />
			<H1 title="Scope of Work" />
			<PARAGRAPH text={c.SOW} />

			<ADDL_SOW />
			<INTENDED_USE />
			<INTENDED_USER />

			<H1 title="Definition of Market Value" />
			<PARAGRAPH text={c.DefOfMarketValue} />
			<PARAGRAPH text={c.DefOfMarketValueAdj} adj />

			<ASSUMTIONS />
			<CERTIFICATIONS />
			<ADDITIONAL_APPRAISER_CERTIFICATIONS />
			<SUPERVISOR_CERTIFICATIONS />
			<ADDITIONAL_SUPERVISOR_CERTIFICATIONS />
		</>
	)
}

export function CERTIFICATIONS() {

	return (
		<>
			<TAB title="Certifications" />
			<H1 title="Appraiser Certifications" />
			{
				c.CertificationText.map((a, ai) => {
					if (ai == 10) {
						let certType = global.ptr.valDetail.ValuationReportInspectionCertificationType;
						if (certType === "Exterior")
							a = c.CertificationText10_1;
						else if (certType === "NoPhysicalInspection")
							a = c.CertificationText10_2;
					} else if (ai === 21) {
						let names = rf.GetCertifcationNames();
						if (names) a = c.CertificationText21_1.replace("[Replacement]", names);
					} else if (ai === 29) {
						if (global.ptr.valDetail.appraiserPriorServicesPerformedIndicator)
							a = c.CertificationText29_1;
					}
					return (<PARAGRAPH key={ai} text={a} />)
				})
			}
		</>
	)
}

export function ADDITIONAL_APPRAISER_CERTIFICATIONS() {
	if (!global.ptr.valRpt.appraiserAdditionalCertificationIndicator) return;
	let addl = rf.GetAdditionalCertifications();

	return (
		<>
			<H2 title="Additional Appraiser Certifications" />
			<PARAGRAPH text={c.AppraiserAddl} />
			{
				addl.map((a, ai) => {
					return (<PARAGRAPH key={ai} text={a} />)
				})
			}

		</>
	)
}

export function SUPERVISOR_CERTIFICATIONS() {

	return (
		<>
			<H1 title="Supervisory Appraiser Certifications" />
			{
				c.SupervisoryCertifications.map((a, ai) => {
					return (<PARAGRAPH key={ai} text={a} />)
				})
			}

		</>
	)
}

export function ADDITIONAL_SUPERVISOR_CERTIFICATIONS() {
	if (!global.ptr.valRpt.appraiserSupervisorAdditionalCertificationIndicator) return;
	let addl = rf.GetAdditionalSupervisorCertifications();

	return (
		<>
			<H2 title="Additional Supervisory Appraiser Certifications" />
			<PARAGRAPH text={c.AppraiserAddl} />
			{
				addl.map((a, ai) => {
					return (<PARAGRAPH key={ai} text={a} />)
				})
			}

		</>
	)
}

function PARAGRAPH({text, cond, adj}) {
	if (cond === false) return undefined;
	let ca = (adj) ? " mprx text-[14px]" : " mpr"
	return (
		<div className={'px-4 pt-2' + ca}>
			<p>{text}</p>
		</div>
	)
}

function ASSUMTIONS() {
	var doFHA = (global.ptr.bFHA && (global.ptr.bPurchase || global.ptr.bRefinance));
	return (
		<>
			<H1 title="Statement of Assumptions and Limiting Conditions" />
			{
				c.Assumptions.map((a, ai) => {
					return (<PARAGRAPH key={ai} text={a} />)
				})
			}
			<PARAGRAPH text={c.AssumptionsFHA} cond={doFHA} />
		</>
	)
}

function ADDL_SOW() {
	if (!global.ptr.sowDetail.valuationAdditionalScopeOfWorkIndicator) return;
	let text = global.ptr.sowDetail.valuationScopeOfWorkDescription;
	return (
		<>
			<H2 title="Additional Scope of Work" />
			<PARAGRAPH text={c.SOWAdditional} />
			<PARAGRAPH text={text} />
		</>
	)
}

function INTENDED_USE() {
  var uses = global.ptr.sow.GetValuationIntendedUses();
	var doGovt = (global.ptr.bFHA && (global.ptr.bPurchase || global.ptr.bRefinance));
	return (
	<>
		<H1 title="Intended Use" />
		<PARAGRAPH text={c.IntendedUse} />
		<PARAGRAPH text={c.IntendedUseGovt} cond={doGovt} />
		<PARAGRAPH text={c.IntendedUseAddl} cond={uses.length > 0} />
		{
			uses.map((u, ui) => {
				return (<PARAGRAPH key={ui} text={u} />)
			})
		}
	</>
	)
}

function INTENDED_USER() {

	let users = [];
	if (global.ptr.sowDetail.ValuationAdditionalIntendedUserIndicator ?? false)
		users = global.ptr.sow.GetValuationIntendedUsers();

	var doFHA = (global.ptr.bFHA && (global.ptr.bPurchase || global.ptr.bRefinance));
	return (
	<>
		<H1 title="Intended User" />
		<PARAGRAPH text={c.IntendedUser} />
		<PARAGRAPH text={c.IntendedUserFHA} cond={doFHA} />
		<PARAGRAPH text={c.IntendedUserUSDA} cond={global.ptr.bUSDA} />
		<PARAGRAPH text={c.IntendedUserVA} cond={global.ptr.bVA} />
		<PARAGRAPH text={c.IntendedUserAddl} cond={users.length > 0} />
		{
			users.map((u, ui) => {
				return (<PARAGRAPH text={u} />)
			})
		}
	</>
	)
}


function AppendCertification(section, index, actualIndex, replacement) {
	let iStr = (actualIndex > 0) ? actualIndex.ToString() : index.ToString();
	let title = iStr + ".";
	let certText = [];

	// if (BReportType == eReportType.Update)
	// 	certText = UpdateCertificationText;
	// else if (BReportType == eReportType.Completion)
	// 	certText = CompletionCertificationText;
	// else
	//	 certText = CertificationText;

	// if (replacement == null)
	// 	AppendCommentaryReadOnly(bottom, label, title, certText[index]);
	// else
	// 	AppendCommentaryReadOnly(bottom, label, title, certText[index].Replace("[Replacement]", replacement));

	return;
	}

